import * as ActionTypes from '../ActionTypes';

export const GetSubscriptionAction = () => {
    return {
        type: ActionTypes.SUBSCRIPTION_GET_REQUEST,
    }
}

export const UpdateSubscriptionAction = (params) => {
    return {
        type: ActionTypes.SUBSCRIPTION_UPDATE_REQUEST,
        params
    }
}